/*
 * Type enum.
 */

export enum OauthClientEditorActionTypesEnum {
  UPDATE_REDIRECT_URLS = '@@oauth_client/UPDATE_REDIRECT_URLS',
}

/*
 * Types.
 */

interface UpdateRedirectUrls {
  type: OauthClientEditorActionTypesEnum.UPDATE_REDIRECT_URLS;
  redirectUrls: string[];
}

/*
 * Combined action type.
 */

export type OauthClientEditorAction = UpdateRedirectUrls;
